// S3 new
import React from 'react';
import { useTranslation } from 'react-i18next';

import IncentiveBadge from 'component/Incentive/Badge';
import { TooltipContentType } from 'component/Incentive/Badge/__config/TooltipContentType';
import { BadgeType } from 'component/Incentive/Badge/types';
import Discount from 'component/Incentive/Tooltip/Content/Discount';
import HolidaySafety from 'component/Incentive/Tooltip/Content/HolidaySafety';
import Text from 'component/Incentive/Tooltip/Content/Text';
import Tooltip from 'component/Layout/Tooltip';
import { TooltipPosition } from 'component/Layout/Tooltip/types';

import { getBadgeType } from 'pages/hotels/component/Layout/Header/__config/BadgeMapping';

import classNames from 'classnames';

import { ReactComponent as IconHolidaySafety } from 'media/svg/holidaySafety.svg';

import styles from './Badge.module.scss';

export interface BadgeProps {
    semBadge: number;
}

const Badge = ({ semBadge }: BadgeProps) => {
    const { t } = useTranslation();
    const badge = getBadgeType(semBadge);
    const tooltipContentType = badge[1];
    const tooltipType = badge[2];
    const tooltipConfig = {
        overlayClassName: styles.Tooltip,
        placement: TooltipPosition.Bottom,
    };
    const getTooltip = (
        tooltipContentType: TooltipContentType,
        tooltipType: string
    ) => {
        if (tooltipType === 'text') {
            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: t(`TRANS-tooltip-${tooltipContentType}`),
                    }}
                />
            );
        }
        switch (tooltipContentType) {
            case TooltipContentType.BEST_PRICE_GUARANTEE:
                return (
                    <Text
                        type={TooltipContentType.BEST_PRICE_GUARANTEE}
                        link={`//${t(
                            'TRANS-base-url-urlaub'
                        )}/tiefstpreisgarantie_popup`}
                    />
                );
            case TooltipContentType.NOWHERE_CHEAPER:
                return (
                    <Text
                        type={TooltipContentType.NOWHERE_CHEAPER}
                        link={`//${t(
                            'TRANS-base-url-urlaub'
                        )}/nirgendwoguenstiger_popup`}
                    />
                );
            case TooltipContentType.VOUCHER_PAYBACK_50:
                return (
                    <Text
                        type={TooltipContentType.VOUCHER_PAYBACK_50}
                        link={`//${t(
                            'TRANS-base-url-customer-area'
                        )}/werbeaktionen/teilnahmebedingungen-gs1331.html`}
                    />
                );

            case TooltipContentType.DISCOUNT:
            case TooltipContentType.EARLY_BIRD:
            case TooltipContentType.EARLY_BIRD_HOLIDAYHOME:
            case TooltipContentType.LAST_MINUTE:
            case TooltipContentType.LAST_MINUTE_HOLIDAYHOME:
                return <Discount type={tooltipContentType} />;
            default:
                return false;
        }
    };

    const tooltip =
        tooltipContentType &&
        tooltipType &&
        getTooltip(tooltipContentType, tooltipType);

    return (
        <>
            <Tooltip
                overlayClassName={styles.Tooltip}
                placement={TooltipPosition.Bottom}
                content={<HolidaySafety />}
                align={{ offset: [0, 10] }}
            >
                <span className={styles.BadgeHolidaySafety}>
                    <IconHolidaySafety />
                </span>
            </Tooltip>
            {badge && (
                <>
                    <span className={styles.BadgePosition}>
                        <IncentiveBadge
                            type={BadgeType.PLECTRUM}
                            customClass={classNames(
                                styles.Badge,
                                styles.MismatchFilterList,
                                {
                                    [styles.WithTooltipIcon]:
                                        tooltipContentType,
                                }
                            )}
                            tooltipContent={tooltip}
                            tooltipConfig={tooltipConfig}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: t(`TRANS-badge-${badge[0]}`),
                                }}
                            />
                        </IncentiveBadge>
                    </span>
                </>
            )}
        </>
    );
};
export default Badge;
